import { configure, Fetch } from '@ekuaibao/fetch';
import { app as api, app } from '@ekuaibao/whispered';
import qs from 'qs';
import { getV, pageViewCacheKey } from '@ekuaibao/lib/lib/help';
import { localCacheSet } from '@ekuaibao/session-info';
import { notifyNetworkStatus, loadManager } from '../lib/performance';
configure({
    hideLoading: window.hideLoading,
    showLoading: window.showLoading,
    handleStatus431: function () {
        var n = new Date().getTime();
        var hash = getV(location, 'hash', '');
        var isAuthPage = hash.includes('/auth-check');
        if (!isAuthPage) {
            api.history.replace('/auth-check');
        }
    },
    networkErrorMessage: function () { return i18n.get('网络无法访问，请检查网络设置'); },
    checkNetworkMessage: function () { return i18n.get('请检查网络'); },
    getStaffId: function () { return api.getState('@common.userinfo.staff.id'); },
    handleErrorCode500: function () {
        window.alertMessage(i18n.get('系统正在处理中，请稍后重试'));
    },
    notifyLoadingChange: notifyNetworkStatus,
});
app.on('hash:change', function () {
    loadManager.abortCurrent();
});
export function go2RedirectUrl(error) {
    return new Promise(function (resolve) {
        var _a = pageViewCacheKey(Fetch.ekbCorpId), beforePagePathKey = _a.beforePagePathKey, beforePageKeyAppId = _a.beforePageKeyAppId, beforePageKey = _a.beforePageKey;
        if (error.status === 401) {
            console.warn('AuthError401', { error: error, corpId: Fetch.ekbCorpId, pathname: location.pathname });
            if (window.IS_SMG && window.location.href.indexOf('/thirdparty') >= 0) {
                alert('授权已失效，请通过10.27.143.43/smgface/single/login页面重新登录');
                resolve('');
            }
            else {
                var urlState = qs.parse(location.search.slice(1));
                if (urlState.overdueTokenRedirect) {
                    location.href = urlState.overdueTokenRedirect;
                }
                else {
                    resolve('');
                }
            }
        }
        else if (error.status === 700) {
            var hash = getV(location, 'hash', '');
            var isMCError = hash.includes('/mc-error');
            if (!isMCError) {
                localCacheSet(beforePageKey, '', true);
                localCacheSet(beforePagePathKey, '', true);
                localCacheSet(beforePageKeyAppId, '', true);
                api.history.replace('/mc-error');
            }
        }
        else if (error.status === 701) {
            var hash = getV(location, 'hash', '');
            var isSharedError = hash.includes('/shared-error') || hash.includes('/login');
            if (!isSharedError) {
                localCacheSet(beforePageKey, '', true);
                localCacheSet(beforePagePathKey, '', true);
                localCacheSet(beforePageKeyAppId, '', true);
                api.history.replace('/shared-error');
            }
        }
        else {
            resolve('');
        }
    });
}
Fetch.go2RedirectUrl = go2RedirectUrl;
export function fetchHandleError(action) {
    Fetch.handleError = function (err) {
        go2RedirectUrl(err).then(function () {
            action && action(err);
        });
    };
}
export default Fetch;
export * from '@ekuaibao/fetch';
